export type PostgreSQLTLSMode = 'verify-full' | 'disable';

export function postgreSQLTLSConfig(sslmode: PostgreSQLTLSMode = 'verify-full', ca = '') {
  return {
    sslmode,
    ...(sslmode === 'verify-full' && ca.trim() ? { ca: ca.trim() } : {}),
  };
}